export default function initSliders() {
  const swiperVideos = new Swiper('.videos__slider', {
    spaceBetween: 20,
    navigation: {
      nextEl: '.videos-button-next',
      prevEl: '.videos-button-prev',
    },
    breakpoints: {
      1199: {
        slidesPerView: 'auto',
      },
      768: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      }
    }
  });

  document.querySelector('.videos-button-next').addEventListener('click', () => {
    swiperVideos.slideNext();
  })
  document.querySelector('.videos-button-prev').addEventListener('click', () => {
    swiperVideos.slidePrev();
  })


  //gallery slider
  const gallerySection = document.querySelector('.gallery');
  const galleryClose = document.querySelector('.gallery__close');
  let savedScrollY = 0;
  let thumbsSwiper;

  function initThumbsSwiper() {
    thumbsSwiper = new Swiper('.thumbs', {
      spaceBetween: 10,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });
  }
  initThumbsSwiper();

  const swiperGallery = new Swiper('.gallery__slider', {
    spaceBetween: 40,
    breakpoints: {
      1199: {
        slidesPerView: 'auto',
      },
      768: {
        slidesPerView: 'auto',
      },
      0: {
        slidesPerView: 1,
      }
    },
    navigation: {
      nextEl: '.gallery-button-next',
      prevEl: '.gallery-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
    },
    grabCursor: true,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
  const savedParams = { ...swiperGallery.params };

  document.querySelector('.gallery-button-next').addEventListener('click', () => {
    swiperGallery.slideNext();
  })
  document.querySelector('.gallery-button-prev').addEventListener('click', () => {
    swiperGallery.slidePrev();
  })

  document.querySelectorAll('.gallery__slide').forEach((img, index) => {
    img.addEventListener('click', () => {
      savedScrollY = window.scrollY;

      gallerySection.classList.add('fullscreen');
      document.body.classList.add('fixed');
      swiperGallery.params.slidesPerView = 1;
      swiperGallery.params.spaceBetween = 0;
      swiperGallery.update();
      thumbsSwiper.update();

      swiperGallery.slideTo(index);
      thumbsSwiper.slideTo(index);
    });
  });

// Закрытие полноэкранного режима
  galleryClose.addEventListener('click', () => {
    gallerySection.classList.remove('fullscreen');
    document.body.classList.remove('fixed');
    swiperGallery.params.slidesPerView = savedParams.slidesPerView;
    swiperGallery.params.spaceBetween = savedParams.spaceBetween;
    swiperGallery.update();
    window.scrollTo(0, savedScrollY);
  });
}
